import OnboardingType from "../../../../../shared/onboarding/onboarding-type";
import { sortByName } from "../../../../../shared/utility";
import { FETCH_MAKEUP_OVERVIEW, SAVE_ALIAS_MAKEUP, SAVE_UNALIAS_MAKEUP, DELETE_MULTIPLE_MAKEUPS } from "./actions";

interface MakeupOverviewState {
    overview: any;
    loading: boolean;
    readOnly: boolean;
    onboardingSteps: OnboardingType[];
    processingMakeupIds: number[];
}

export const OnboardingStep1ClassName = 'makeup-overview-onboarding-step-1';
export const OnboardingStep2ClassName = 'makeup-overview-onboarding-step-2';
export const OnboardingStep3ClassName = 'makeup-overview-onboarding-step-3';
export const OnboardingStep4ClassName = 'makeup-overview-onboarding-step-4';

const defaultState: MakeupOverviewState = {
    overview: {},
    loading: true,
    readOnly: false,
    onboardingSteps: [
        {
            target: '.' + OnboardingStep1ClassName,
            title: 'Merge Makeup',
            content: `<p>Drag and drop makeup on top of each other to merge them.</p>
       <p>This is useful for combining duplicate makeup or aliasing makeup that are the same but have different names.</p>`
        }
    ],
    processingMakeupIds: [],
};

const reducer = (state = defaultState, action: any = {}) => {
    switch (action.type) {
        case FETCH_MAKEUP_OVERVIEW + "_PENDING": {
            return {
                ...state,
                loading: true,
                overview: null,
                errors: null
            };
        }

        case FETCH_MAKEUP_OVERVIEW + "_FULFILLED": {
            return {
                ...state,
                loading: false,
                overview: action.payload.data,
                errors: null
            };
        }

        case SAVE_ALIAS_MAKEUP + "_PENDING": {
            // Add both IDs to processingMakeupIds
            const { aliasMakeup, preferredMakeup } = action.meta || {};
            const ids = [aliasMakeup?.id, preferredMakeup?.id].filter((id) => id !== undefined);
            return {
                ...state,
                processingMakeupIds: [...new Set([...(state.processingMakeupIds || []), ...ids])]
            };
        }

        case SAVE_ALIAS_MAKEUP + "_FULFILLED": {
            const aliasMakeup = action.meta.aliasMakeup;
            const preferredMakeup = action.meta.preferredMakeup;
            let makeups = [...state.overview.makeups];
            const makeup = makeups.find((c) => c.id === preferredMakeup.id);
            const aliasMakeupIndex = makeups.findIndex(
                (c) => c.id === aliasMakeup.id
            );

            if (makeup.aliases) {
                makeup.aliases = [
                    ...makeup.aliases,
                    aliasMakeup
                ];
            } else {
                makeup.aliases = [aliasMakeup];
            }

            makeups[aliasMakeupIndex].aliases = [];

            makeups.splice(aliasMakeupIndex, 1);
            let overview = { ...state.overview, makeups };
            // Remove both IDs from processingMakeupIds
            const ids = [aliasMakeup?.id, preferredMakeup?.id].filter((id) => id !== undefined);
            return {
                ...state,
                overview,
                processingMakeupIds: (state.processingMakeupIds || []).filter((id) => !ids.includes(id))
            };
        }

        case SAVE_ALIAS_MAKEUP + "_REJECTED": {
            // Remove both IDs from processingMakeupIds
            const { aliasMakeup, preferredMakeup } = action.meta || {};
            const ids = [aliasMakeup?.id, preferredMakeup?.id].filter((id) => id !== undefined);
            return {
                ...state,
                errors: action.payload.response?.data?.errors,
                processingMakeupIds: (state.processingMakeupIds || []).filter((id) => !ids.includes(id))
            };
        }

        case SAVE_UNALIAS_MAKEUP + "_PENDING": {
            // Add both IDs to processingMakeupIds
            const { aliasMakeup, preferredMakeup } = action.meta || {};
            const ids = [aliasMakeup?.id, preferredMakeup?.id].filter((id) => id !== undefined);
            return {
                ...state,
                processingMakeupIds: [...new Set([...(state.processingMakeupIds || []), ...ids])]
            };
        }

        case SAVE_UNALIAS_MAKEUP + "_FULFILLED": {
            const aliasMakeup = action.meta.aliasMakeup;
            const preferredMakeup = action.meta.preferredMakeup;
            let makeups = [...state.overview.makeups];
            const makeup = makeups.find((c) => c.id === preferredMakeup.id);

            const aliasMakeupIndex = makeup.aliases.findIndex(
                (a) => a.id === aliasMakeup.id
            );
            makeup.aliases.splice(aliasMakeupIndex, 1);

            aliasMakeup.scriptDays = action.payload.data.scriptDays;
            makeups.push(aliasMakeup);

            sortByName(makeups);

            let overview = { ...state.overview, makeups };
            // Remove both IDs from processingMakeupIds
            const ids = [aliasMakeup?.id, preferredMakeup?.id].filter((id) => id !== undefined);
            return {
                ...state,
                overview,
                processingMakeupIds: (state.processingMakeupIds || []).filter((id) => !ids.includes(id))
            };
        }
        case SAVE_UNALIAS_MAKEUP + "_REJECTED": {
            // Remove both IDs from processingMakeupIds
            const { aliasMakeup, preferredMakeup } = action.meta || {};
            const ids = [aliasMakeup?.id, preferredMakeup?.id].filter((id) => id !== undefined);
            return {
                ...state,
                errors: action.payload.response?.data?.errors,
                processingMakeupIds: (state.processingMakeupIds || []).filter((id) => !ids.includes(id))
            };
        }

        case DELETE_MULTIPLE_MAKEUPS + "_PENDING": {
            return {
                ...state,
                loading: true,
                errors: null
            };
        }

        case DELETE_MULTIPLE_MAKEUPS + "_FULFILLED": {
            const deletedMakeupIds = action.meta.makeupIds;
            let makeups = state.overview.makeups.filter(
                (makeup) => !deletedMakeupIds.includes(makeup.id)
            );

            let overview = { ...state.overview, makeups };
            return {
                ...state,
                overview: overview,
                loading: false
            };
        }

        case DELETE_MULTIPLE_MAKEUPS + "_REJECTED": {
            return {
                ...state,
                errors: action.payload.response.data.errors,
                loading: false
            };
        }

        default:
            return state;
    }
};

export default reducer;
